const newTrackEvents = {

    "prizes": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'prizes',
        pageType: 'article',
        pageSubType: 'prizes',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/prizes/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "prizes-landing": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'landing',
        pageType: 'landing',
        pageSubType: 'prizes',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/prizes/landing/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "rules": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'rules',
        pageType: 'article',
        pageSubType: 'rules',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/rules/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "rules-landing": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'landing',
        pageType: 'landing',
        pageSubType: 'rules',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/rules/landing/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "help": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'help',
        pageType: 'help',
        pageSubType: undefined,
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/help/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "landingPage1": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'landing',
        pageType: 'landing',
        pageSubType: 'promo',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/landing/1st/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "landingPage2": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'landing',
        pageType: 'landing',
        pageSubType: 'promo',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/landing/2nd/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "landingPage3": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'landing',
        pageType: 'landing',
        pageSubType: 'promo',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/landing/3rd/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "substitution": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageType: 'edit',
        pageSubType: 'substitutions mode',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '	/uefaeuro2020fantasyfootball/my-team/substitutions/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "transfer": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageType: 'edit',
        pageSubType: 'transfer mode',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/my-team/transfers/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "live": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageType: 'view',
        pageSubType: 'my team locked',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/my-team/view/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "globalRank": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'leaderboard',
        pageSubType: 'global overall',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/public/global-rank/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "country": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'leaderboard',
        pageSubType: 'country',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/public/{country}/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "club": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'leaderboard',
        pageSubType: 'club',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/public/{club}/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "knockout": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'leaderboard',
        pageSubType: 'club',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/public/{knockout}/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "emptyLeague": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'empty state',
        pageSubType: 'empty league',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/empty/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "emptyLeagueDetails": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'empty state',
        pageSubType: 'empty league',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/private/empty/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "LeagueDetails": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'leaderboard',
        pageSubType: 'league',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/private/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "leagues": {
        event: 'Page Meta',
        pageSubType: 'leagues',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'list',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "LeagueInviteLayer": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        pageSubType: 'league invite',
        contentSection3: 'leagues',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageType: 'share',
        pageName: '/uefaeuro2020fantasyfootball/leagues/private/invite/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "LeagueSettings": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'settings',
        pageSubType: 'league',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/private/settings/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "LeagueSettingsEdit": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'settings',
        pageSubType: 'league edit',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/private/settings/edit/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "createLeague": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'create league',
        pageSubType: undefined,
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/private/create/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "joinLeague": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'join league',
        pageSubType: undefined,
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/private/join/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "league-leaderboard": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'leaderboard',
        pageSubType: 'league',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/private/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "viewOthersTeam": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'leagues',
        pageType: 'fantasy team',
        pageSubType: 'others team view',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/leagues/others-team/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "myTeam": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageType: 'view',
        pageSubType: 'manage my team',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/my-team/manage/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    'substitution': {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageType: 'edit',
        pageSubType: 'substitutions mode',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageName: '/uefaeuro2020fantasyfootball/my-team/substitutions/',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "fantasyeditorialall": {
        event: 'Page Meta',
        pageName: '/uefaeuro2020fantasyfootball/stories/',
        pageType: 'hub',
        pageSubType: 'news&video',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'news',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "fantasyeditorialarticle": {
        event: 'Page Meta',
        pageName: '/gaminghub/news/{articleId}/',
        pageType: 'article',
        pageSubType: 'uefaeuro2020fantasyfootball',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'news',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "create-team": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/create-team/',
        pageType: 'create',
        pageSubType: 'player selection',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "select-captain-screen": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/select-captain/',
        pageType: 'create',
        pageSubType: 'select captain',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },

    "save-team-name": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/team-name/',
        pageType: 'create',
        pageSubType: 'enter team name',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "save-team": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/save-team/',
        pageType: 'create',
        pageSubType: 'team summary',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "home": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/home/',
        pageType: 'hub',
        pageSubType: undefined,
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    // check - what is the difference with manage-team-trans? I think that the pageType: 'view', here becasue I guess its viewing a team?
    "myTeam-trans": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/my-team/manage/{matchdayname}/',
        pageType: 'view',
        pageSubType: 'manage my team',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "myTeam-subs": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/my-team/substitution/{matchdayname}/',//done
        pageType: 'view',
        pageSubType: 'manage my team',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "myTeam-viewpoints": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/my-team/view/{matchdayname}/',//not
        pageType: 'view',
        pageSubType: undefined,
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "myTeam-live": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/my-team/view/{matchdayname}/',//done
        pageType: 'view',
        pageSubType: 'my team locked',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "manage-team-trans": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/my-team/transfers/{matchdayname}/',//done
        pageType: 'edit',
        pageSubType: 'transfer mode',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "manage-team-subs": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/my-team/substitutions/',
        pageType: 'edit',
        pageSubType: 'substitutions mode',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "transfer-summary": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/my-team/transfers/summary/',
        pageType: 'game entry',
        pageSubType: 'transfers summary',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "matchesPopUp": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/upcoming-fixtures/',
        pageType: 'match listing',
        pageSubType: 'match calendar',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "matchesPage": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/matches/{matchday}/',
        pageFormat: 'standard view',
        pageSubType: 'match calendar',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageType: 'match listing',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "matchesDetails": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/matches/detail/',
        pageType: 'match',
        pageSubType: 'match',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    "gamesettings": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: undefined,
        pageName: '/uefaeuro2020fantasyfootball/settings/',
        pageType: 'settings',
        pageSubType: 'team name edit',
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    },
    // check - is this the rules landing page?
    "howToplay": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uefaeuro2020fantasyfootball',
        contentSection3: 'landing',
        pageName: '/uefaeuro2020fantasyfootball/howtoplay/',
        pageType: 'landing',
        pageSubType: undefined,
        pageTitle: 'UEFA EURO 2020 – Fantasy Football – UEFA.com',
        pageFormat: 'standard view',
        type: "new",
        competition: "euro",
        competitionDate: "2020"
    }
}

export default newTrackEvents